import React from 'react';
import { LocalizationProvider, DesktopDatePicker as NativeDesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { pt } from 'date-fns/locale';
import { styled } from '@mui/material';
import './index.css';

const CustomNativeDesktopDatePicker = styled(NativeDesktopDatePicker)({
  '& button': {
    padding: 0,
  },
  '& input': {
    paddingRight: '0px !important',
  },
});

const KeyboardDatePicker: React.FC<any> = ({
  value,
  onChange,
  label,
  margin = 'none',
  textFieldProps,
  slotProps,
  ...rest
}) => {
  return (
    <LocalizationProvider adapterLocale={pt} dateAdapter={AdapterDateFns}>
      <CustomNativeDesktopDatePicker
        slotProps={{ ...slotProps, textField: textFieldProps }}
        openTo="day"
        label={label}
        value={value}
        sx={{
          '& .MuiInputBase-root': {
            padding: '0px !important',
          },
          margin: margin === 'none' ? '0px!important' : '16px 0px 8px 0px!important',
          width: '100%',
        }}
        onChange={onChange}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default KeyboardDatePicker;
